import {
  BuildingLibraryIcon,
  NewspaperIcon,
  ClipboardDocumentListIcon,
  EnvelopeIcon,
  BuildingOfficeIcon,
  ComputerDesktopIcon,
} from "@heroicons/react/24/solid";

import BusinessOperation from "../BusinessOperation";
import OfficeStatusDetails from "./OfficeStatusDetails";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import GLEntity from "./GLEntity";
import OfficeBrand from "./OfficeBrand";
import OfficeStatus from "./OfficeStatus";
import OfficeType from "./OfficeType";
import Channel from "./Channel";
import SalesType from "./SalesType";
import OfficeOrigin from "./OfficeOrigin";
import OfficeDivision from "./OfficeDivision";
import TargetSystem from "./TargetSystem";
import TexasGrouping from "./TexasGrouping";
import OfficeDepartment from "./OfficeDepartment";
import OfficeBMO from "./BMO";
import OfficeBank from "./OfficeBank";
import AcquisitionConfiguration from "./AcquisitionConfiguration";
import OfficeAccount from "./OfficeAccount";

export const OfficeTabs = [
  {
    to: ROUTE_PATHS.Utilities_Office_GLEntity_Index,
    icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2 " />,
    title: "GL Entity",
    component: GLEntity,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_glentity_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_OfficeBrand_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Office Brand",
    component: OfficeBrand,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officebrand_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_OfficeStatus_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Status",
    component: OfficeStatus,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officestatus_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_OfficeType_Index,
    icon: <EnvelopeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Type",
    component: OfficeType,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officetype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_Channel_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
    title: "Channel",
    component: Channel,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_channel_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_SalesType_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
    title: "Sales Type",
    component: SalesType,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_salestype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_OfficeOrigin_Index,
    icon: <EnvelopeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Origin",
    component: OfficeOrigin,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officeorigin_view,
  },
  {
    to: ROUTE_PATHS.Utilities_BusinessOperation_Index,
    path: ROUTE_PATHS.Utilities_BusinessOperation_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Business Operation",
    component: BusinessOperation,
    permission: PERMISSIONS.permission_utilities_businessoperation_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_StatusDetails_Index,
    to: ROUTE_PATHS.Utilities_Office_StatusDetails_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Status Details",
    component: OfficeStatusDetails,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officestatusdetails_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Office_OfficeDivision_Index,
    path: ROUTE_PATHS.Utilities_Office_OfficeDivision_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Division",
    component: OfficeDivision,
    permission: PERMISSIONS.permission_utilities_officedivision_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_TargetSystem_Index,
    to: ROUTE_PATHS.Utilities_Office_TargetSystem_Index,
    icon: <ComputerDesktopIcon className="h-4 w-4 float-left mr-2" />,
    title: "Policy Management System",
    component: TargetSystem,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_targetsystem_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_TexasGroupings_Index,
    to: ROUTE_PATHS.Utilities_Office_TexasGroupings_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Texas Grouping",
    component: TexasGrouping,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_texasgrouping_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_OfficeDepartment_Index,
    to: ROUTE_PATHS.Utilities_Office_OfficeDepartment_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Department",
    component: OfficeDepartment,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officedepartment_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_BMO,
    to: ROUTE_PATHS.Utilities_Office_BMO,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "BMO",
    component: OfficeBMO,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officebmo_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_OfficeBank,
    to: ROUTE_PATHS.Utilities_Office_OfficeBank,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Bank",
    component: OfficeBank,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officebank_view,
  },
  {
    path: ROUTE_PATHS.Utilities_AcquisitionConfiguration_Index,
    to: ROUTE_PATHS.Utilities_AcquisitionConfiguration_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Acquisition",
    component: AcquisitionConfiguration,
    permission: PERMISSIONS.permission_utilities_acquisitionconfiguration_view,
  },
  {
    path: ROUTE_PATHS.Utilities_Office_OfficeAccount_Index,
    to: ROUTE_PATHS.Utilities_Office_OfficeAccount_Index,
    icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Office Account",
    component: OfficeAccount,
    permission:
      PERMISSIONS.permission_utilities_officeconfiguration_officeaccount_view,
  },
];
